// frontend/user/src/components/multi-select-header.tsx
// .pen BLWNx M2iCN1 / UGuBc A4pLeS — 多选模式头部行:取消 | 已选 N 项 | 全选。
type Props = {
  count: number
  allSelected: boolean
  onCancel: () => void
  onToggleAll: () => void
}

export function MultiSelectHeader({ count, allSelected, onCancel, onToggleAll }: Props) {
  return (
    <div data-testid="multi-select-header" className="flex h-12 items-center justify-between">
      <button type="button" data-testid="multi-cancel-btn" onClick={onCancel} className="text-[17px] font-medium text-[#19caad]">
        取消
      </button>
      <span data-testid="multi-count" className="text-[17px] font-semibold text-[#1A1A1A]">
        已选 {count} 项
      </span>
      <button type="button" data-testid="multi-select-all-btn" onClick={onToggleAll} className="text-[17px] font-medium text-[#19caad]">
        {allSelected ? '取消全选' : '全选'}
      </button>
    </div>
  )
}
